module.exports = __webpack_public_path__ + "static/img/new-21.d2f848e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-21.png
// module id = InZZ
// module chunks = 0